import * as React from "react"
import { Color, FontSize } from "../../../constants"

type Props = {
    value: string | React.ReactNode
    subValue: string | React.ReactNode
}

const TwoRowsHeaderCell = (props: Props) => {
    return (
        <div className="twoRowsCell">
            <style jsx={true}>
                {`
                    .twoRowsCell {
                        white-space: nowrap;
                        position: relative;
                        display: inline-block;
                    }
                    .twoRowsCell .value {
                        position: relative;
                        top: -8px;
                    }
                    .twoRowsCell .subValue {
                        color: ${Color.Grey6};
                        font-size: ${FontSize.xs};
                        position: absolute;
                        margin-top: -6px;
                    }
                `}
            </style>
            <div className="value">{props.value}</div>

            <div className="subValue">{props.subValue}</div>
        </div>
    )
}

export default TwoRowsHeaderCell
